import sum from 'lodash/sum';

const calcTotalChargers = ({chargerSets}) => sum(chargerSets.map((set) => set.chargerCount));

export default calcTotalChargers;
